import React from 'react';

function Footer() {
  return (
    <footer>
      <ul>
      <li>
        <a href="https://github.com/lshillman/" target="_blank">Github</a>
      </li>
      <li>
        <a href="https://www.linkedin.com/in/lshillman/" target="_blank">LinkedIn</a>
      </li>
      <li>
        <a href="https://twitter.com/lshillman" target="_blank">Twitter</a>
      </li>
      </ul>
    </footer>
  );
}

export default Footer;
